import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: 1.5rem;
	margin-top: auto;
`;
